import { Component, Inject, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { getMandant, getMandanten, getMandantenFehler, getMandantenLaden, PageState } from './mandanten-auswahl.reducer';
import { Observable } from 'rxjs';
import { GetMeineMandantenAction } from './../../../client-ngrx/api';
import {MandantAusgewaehltUiAction, MandantSetzenAction} from '@orga-app/mandant/actions';
import { MandantInfo } from './../../../clients/api';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvironmentOptions } from '@orga-app/env';
import {Settings, SettingsProvider} from '@orga-app/settings';
import {SafeUrl} from '@angular/platform-browser';
import {getTheme} from '@orga-app/settings/reducer';


@Component({
  selector: 'app-mandanten-auswahl',
  templateUrl: './mandanten-auswahl.page.html',
  styleUrls: ['./mandanten-auswahl.page.scss'],
})
export class MandantenAuswahlPage implements OnInit {
  public settings$: Observable<Settings>;
  themeDefault$: Observable<Settings>;
  logoHeaderSVG$: Observable<SafeUrl>;

  public mandanten$: Observable<Array<MandantInfo>>;
  public mandantenLaden$: Observable<boolean>;
  public mandantenFehler$: Observable<boolean>;
  public mandant$: Observable<MandantInfo>;


  constructor(private store: Store<PageState>
    , private route: ActivatedRoute
    , private router: Router
    , private envi: EnvironmentOptions
    , private settingsProvider: SettingsProvider
  ) {
    this.themeDefault$ = this.settingsProvider.getThemeDefault();
    this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
    this.settings$ = this.store.pipe(select(getTheme));
  }

  ngOnInit() {
    this.mandanten$ = this.store.pipe(select(getMandanten));
    this.mandantenLaden$ = this.store.pipe(select(getMandantenLaden));
    this.mandantenFehler$ = this.store.pipe(select(getMandantenFehler));
    this.mandant$ = this.store.pipe(select(getMandant));
  }

  ionViewDidEnter() {
    // console.log('MandantenAuswahlPage:: ionViewWillEnter');
   // this.viewWillEnterPage().then();
    console.log('MandantenAuswahlPage:: ionViewDidEnter');
    this.store.dispatch(new GetMeineMandantenAction(true, 50, 50));
  }

  // async viewWillEnterPage() {
  //   console.log('MandantenAuswahlPage:: viewWillEnterPage');
  //   // await this.store.dispatch(new PageStateResetAction());
  //   await this.mandantenLaden();
  // }

  async mandantenLaden() {
    console.log('MandantenAuswahlPage:: mandantenLaden');
    this.store.dispatch(new GetMeineMandantenAction(true, 50, 50));
  }

  async mandantAuswaehlen(mandant: MandantInfo) {
    this.store.dispatch(new MandantSetzenAction(mandant));
    // this.store.dispatch(new MandantAusgewaehltUiAction(mandant));

    // console.log("routerState", this.router.routerState);
    // console.log("route", this.route);

    this.route.paramMap.subscribe(p => {
      
      let target = this.envi.homeRoute;

      if (p.has('returnTo')) {
        target = p.get('returnTo');
      }

      console.debug('navigate to target:', target);
      this.router.navigateByUrl(target);
    });
    
  }
}
